<template>
  <div :key="componentKey" class="mb-5">
    <SectionTitle :content="model.name" :has-line="true" />
    <template v-for="item in model.questions">
      <Question
        :key="item.id"
        :model="item"
        :readonly="readonly"
        @selected="onClickChild"
      />
    </template>
  </div>
</template>
<script>
import Question from './Question';
import { SectionTitle } from '@/components/pei/shared';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Question,
    SectionTitle,
  },
  data() {
    return {
      componentKey: 0,
      isValid: false,
    };
  },
  methods: {
    validate() {
      let question10 = 1;
      const questionsRequired = [2, 3, 4, 5, 6, 7];
      questionsRequired.forEach((questionId) => {
        this.list.forEach((section) => {
          section.questions.find((question) => {
            if (
              question.id === questionId &&
              (question.selected === 2 || !question.selected)
            ) {
              question10 = 2;
              return;
            }
          });
        });
      });

      const section2 = this.list.find((x) => x.id === 2);
      const question7 = section2.questions.find((x) => x.id === 8);
      if (question10 && question7.selected === 1) {
        const question7a = section2.questions.find((x) => x.id === 10);
        if (question7a.selected === 2 || !question7a.selected) {
          question10 = 2;
        }
      }

      const questionB13Ids = [15, 753];
      this.model.questions.find((x) =>
        questionB13Ids.some((id) => id === x.id)
      ).selected = question10;
      this.isValid = this.model.questions.findIndex((x) => !x.selected) === -1;

      let question9 = this.model.questions.find((x) => x.id === 14);
      if (question9 !== undefined && question9.selected === 1) {
        question9.openAnswer = '';
      }

      this.componentKey += 1;
      this.$emit('changed', this.model, this.isValid);
    },

    onClickChild() {
      this.validate();
    },
  },
  mounted() {},
};
</script>
